import { render, staticRenderFns } from "./researchPractice.vue?vue&type=template&id=457fcd71&scoped=true&"
import script from "./researchPractice.vue?vue&type=script&lang=js&"
export * from "./researchPractice.vue?vue&type=script&lang=js&"
import style0 from "./researchPractice.vue?vue&type=style&index=0&id=457fcd71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fcd71",
  null
  
)

export default component.exports